const Layout = ({ children }) => {
  return (
    <>
      <div className="container-fluid main d-flex">{children}</div>
    </>
  );
};

export default Layout;
